import React from 'react';

import {
  Box,
  BoxProps,
} from '@waglabs/box-next';

export type HiddenRadioInputProps = BoxProps;
export const HiddenRadioInput = ({
  style = {},
  ...rest
}: HiddenRadioInputProps) => (
  <Box
    as="input"
    type="radio"
    position="absolute"
    {...rest}
    style={{
      visibility: 'hidden',
      ...style,
    }}
  />
);
